import "@styles/exames-procedimentos.css";
import React, { Component } from "react";
import {
  getProfissionaisSolicitantesFiltro,
  getOcupacoes,
  getEstados,
  getConselhos,
} from "@store/actions/index";
import {
  selectFieldStyle,
  selectFieldStyleError,
  selectFieldWithNoIndicator,
} from "@utils/const";
import { Form, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import Select from "react-select";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import m from "@utils/strings";
import _ from "lodash";
import { removeAccents } from "@utils/stringUtil";
import InclusaoProfissional from "../profissional/InclusaoProfissional";
import CustomSnackbar from "../shared/custom_snackbar";

class FormSolicitacao extends Component {
  constructor(props) {
    super(props);

    this.estados = [];
    this.conselhos = [];

    this.state = {
      hasSubmitted: false,
      nomeDoProfissionalSelecionado: "",
      estadoSelecionado: "",

      ocupacoes: [],
      ocupacaoSelecionada: { value: "", label: "" },

      conselhoSelecionado: "",
      numeroConselhoSelecionado: "",

      profissionalSelecionado: "",
      profissionaisSolicitantesToRender: [], //pega uma fracao de dados do array profissionaisSolicitantesToFilter para exibir
      profissionaisSolicitantesOcupacoes: [],

      blockFields: false,
      snackbarMsg: "",
      snackType: "error",
      loadingProfissional: false,
    };

    this.focus = this.focus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSetInitialFieldsStateSolicitacao =
      this.handleSetInitialFieldsStateSolicitacao.bind(this);
    this.handleValidateSolicitacaoFields =
      this.handleValidateSolicitacaoFields.bind(this);
  }

  componentDidMount() {
    this.loadInputDatas();
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.setInitialFieldsState(
      this.handleSetInitialFieldsStateSolicitacao
    );
    this.props.validateSolicitacaoFields(this.handleValidateSolicitacaoFields);
    this.props.focusFirstFieldSolicitacao(this.focus);
    this.props.blockAllFields(this.blockAllFields);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    if (
      event.key === "Enter" &&
      this.props.activeAccordion == "2" &&
      this.state.profissionalSelecionado &&
      !this.state.blockFields
    ) {
      this.handleSubmit();
      event.preventDefault();
    } else if (event.key === "Enter" && this.state.blockFields) {
      this.props.resetAllStates();
    } else if (event.key === "Enter") {
      event.preventDefault();
    }
  }

  focus() {
    setTimeout(() => {
      this.textInput.focus();
    }, 1000);
  }

  loadInputDatas = () => {
    this.props.getOcupacoes((result) => {
      let ocupacoesInput = result.data.map((ocupacao) => {
        return {
          Descricao: ocupacao.Descricao,
          Id: ocupacao.Id,
        };
      });
      this.setState({ ocupacoes: ocupacoesInput });
    });
    this.props.getEstados((result) => {
      let estados = result.data.map((estado) => {
        return estado.Descricao;
      });
      this.estados = estados;
    });
    this.props.getConselhos((result) => {
      let conselhos = result.data.map((conselho) => {
        return conselho.Descricao;
      });
      this.conselhos = conselhos;
    });
  };

  blockAllFields = () => {
    this.setState({ blockFields: true });
  };

  prencherListagem = (result) => {
    let arrayToRender = [];

    this.setState({ loadingProfissional: true });

    if (result?.data?.length ?? 0 > 0) {
      let profissionaisInput = result.data.map((profissional) => {
        return profissional.Profissional;
      });

      arrayToRender = profissionaisInput.map((profissional) => {
        return {
          value: profissional,
          profissional: profissional,
          label: `${profissional.Nome} - ${profissional.Conselho}-${profissional.Estado} ${profissional.Numeroconselho}`,
        };
      });

      this.setState({
        profissionaisSolicitantesToRender: arrayToRender,
        profissionaisSolicitantesOcupacoes: result.data,
        loadingProfissional: false,
      });
    } else {
      this.setState({
        profissionaisSolicitantesToRender: arrayToRender,
        loadingProfissional: false,
      });
    }
  };

  onProfissionalInputChange = (inputValue) => {
    inputValue = inputValue.toUpperCase(removeAccents(inputValue));

    try {
      if (inputValue.length < 3) {
        this.setState({
          profissionaisSolicitantesToRender: [],
          profissionaisSolicitantesOcupacoes: [],
        });
      } else {
        this.setState({ loadingProfissional: true });

        // Deverá buscar filtro na listagem do back
        this.props.getProfissionaisSolicitantesFiltro(
          inputValue,
          this.prencherListagem
        );
      }
    } catch (error) {
      this.setState({ loadingProfissional: false });
    }
  };

  profissionalSolicitanteSelect = (event) => {
    this.setState({ profissionalSelecionado: event });
    let getOcupacaoDoProfissional;
    var ocupacaoSelecionada;
    if (event.profissional)
      this.state.profissionaisSolicitantesOcupacoes.forEach((Profissional) => {
        if (event.profissional.Nome == Profissional.Profissional.Nome)
          getOcupacaoDoProfissional = Profissional;
      });

    let ocupacoesDoProfissionalQueExistemEmBanco = [];
    if (getOcupacaoDoProfissional) {
      this.state.ocupacoes.forEach((ocupacao) => {
        if (getOcupacaoDoProfissional.Ocupacoes.length == 1) {
          if (
            ocupacao.Descricao ==
            getOcupacaoDoProfissional.Ocupacoes[0].Descricao
          ) {
            ocupacaoSelecionada = {
              value: ocupacao.Descricao,
              label: `${ocupacao.Id} - ${ocupacao.Descricao}`,
            };
            this.ocupacaoSelect(ocupacaoSelecionada, event.Profissional, false);
          }
        } else if (getOcupacaoDoProfissional.Ocupacoes.length > 1) {
          getOcupacaoDoProfissional.Ocupacoes.forEach(
            (ocupacaoProfissional) => {
              if (ocupacao.Descricao == ocupacaoProfissional.Descricao)
                ocupacoesDoProfissionalQueExistemEmBanco.push({
                  descricao: ocupacao.Descricao,
                  id: ocupacao.Id,
                });
            }
          );
        }
      });
    }

    let reorderOcupacoes = [];
    ocupacoesDoProfissionalQueExistemEmBanco.forEach((ocupacao) => {
      reorderOcupacoes.push(ocupacao);
    });
    this.state.ocupacoes.forEach((ocupacao) => {
      let alreadyThere = false;
      reorderOcupacoes.forEach((ocupacaoDoProfissional) => {
        if (ocupacao.Descricao == ocupacaoDoProfissional.Descricao)
          alreadyThere = true;
      });
      if (!alreadyThere) reorderOcupacoes.push(ocupacao);
    });

    this.setState({ ocupacoes: reorderOcupacoes });
    if (event.profissional != null) {
      let profissionalToUpdate = event.profissional;

      profissionalToUpdate.ocupacao =
        ocupacaoSelecionada != null
          ? this.findIdOcupacao(ocupacaoSelecionada)
          : this.findIdOcupacao();
      if (!_.isEmpty(profissionalToUpdate.ocupacao)) {
        this.props.updateDadosSolicitacao(
          {
            profissionalExecutante: profissionalToUpdate,
          },
          () => {
            if (!_.isEmpty(this.state.ocupacaoSelecionada)) {
              setTimeout(() => {
                this.props.openNextAccordion();
              }, 100);
            }
          }
        );
      }
    }
  };

  ocupacaoSelect = (event, profissional = null, openNextAccordion = true) => {
    this.setState({ ocupacaoSelecionada: event }, () =>
      this.onOcupacaoSelecionadaStateChanged(
        event,
        profissional,
        openNextAccordion
      )
    );
  };

  onOcupacaoSelecionadaStateChanged = (
    event,
    profissional,
    openNextAccordion
  ) => {
    if (
      this.state.profissionalSelecionado.profissional != null ||
      profissional != null
    ) {
      let profissionalToUpdate = !_.isEmpty(profissional.value)
        ? profissional
        : this.state.profissionalSelecionado.profissional;
      if (profissionalToUpdate) {
        profissionalToUpdate.ocupacao = this.findIdOcupacao(event);
        this.props.updateDadosSolicitacao(
          {
            profissionalExecutante: profissionalToUpdate,
          },
          () => {
            if (openNextAccordion) {
              this.props.openNextAccordion();
            }
          }
        );
      }
    }
  };

  estadoSelect = (event) => {
    this.setState({ estadoSelecionado: event });
  };

  conselhoSelect = (event) => {
    this.setState({ conselhoSelecionado: event });
  };

  nomeDoProfissionalSelect = (event) => {
    let value = event.target.value;
    if (value.length > 70) value = value.substring(0, value.length - 1);
    this.setState({ nomeDoProfissionalSelecionado: value });
  };

  numeroConselhoSelect = (event) => {
    let value = event.target.value;
    value = value.replace(/([.*+?^=!:;"'´`~&%$#@${}()|\[\]\\a-zA-Z\/\-])/g, "");
    if (value.length > 15) value = value.substring(0, value.length - 1);
    this.setState({ numeroConselhoSelecionado: value });
  };

  findIdOcupacao = (ocupacao = null) => {
    let returnVar = {};
    let ocupacaoSelecionada;
    if (ocupacao) {
      ocupacaoSelecionada = ocupacao.value;
    } else {
      ocupacaoSelecionada = this.state.ocupacaoSelecionada.value;
    }
    this.state.ocupacoes.forEach((ocupacao) => {
      if (ocupacao.Descricao == ocupacaoSelecionada)
        returnVar = {
          descricao: ocupacao.Descricao,
          id: ocupacao.Id,
        };
    });
    return returnVar;
  };

  handleSubmit = () => {
    this.setState({ hasSubmitted: true });

    if (
      this.state.ocupacaoSelecionada &&
      !_.isEmpty(this.state.ocupacaoSelecionada.label) &&
      this.state.estadoSelecionado &&
      this.state.conselhoSelecionado &&
      this.state.nomeDoProfissionalSelecionado &&
      this.state.numeroConselhoSelecionado
    ) {
      this.props.updateDadosSolicitacao({
        profissionalExecutante: {
          conselho: this.state.conselhoSelecionado.value,
          estado: this.state.estadoSelecionado.value,
          nome: this.state.nomeDoProfissionalSelecionado,
          numeroconselho: this.state.numeroConselhoSelecionado,
          ocupacao: this.findIdOcupacao(),
        },
      });
      this.setState({ hasSubmitted: false });
      setTimeout(() => {
        this.props.openNextAccordion();
      }, 500);
    }
  };

  handleValidateSolicitacaoFields = () => {
    this.handleSubmit();
  };

  handleSetInitialFieldsStateSolicitacao = () => {
    this.setState({
      hasSubmitted: false,
      nomeDoProfissionalSelecionado: "",
      estadoSelecionado: { value: "", label: "" },
      ocupacaoSelecionada: { value: "", label: "" },

      conselhoSelecionado: { value: "", label: "" },
      numeroConselhoSelecionado: "",

      profissionalSelecionado: { value: "", label: "" },
      profissionaisSolicitantesToRender: [], //com opção default

      blockFields: false,
    });
  };

  mapFilterArrayToRenderArray = (field, value) => {
    value = value.toUpperCase();
    value = removeAccents(value);
    field.label = field.label.toUpperCase();
    field.label = removeAccents(field.label);
    if (field.label.includes(value)) return true;
    else return false;
  };

  render() {
    return (
      <div className={"form-accordion"}>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Field
              inline={true}
              width={10}
              disabled={this.state.blockFields}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_PROFISSIONAL_SOLICITANTE}
                </label>
              </div>
              <Select
                value={this.state.profissionalSelecionado}
                onChange={this.profissionalSolicitanteSelect}
                placeholder={
                  m.TELA_EXAMES_PROCEDIMENTOS
                    .PLACEHOLDER_PROFISSIONAL_SOLICITANTE
                }
                isDisabled={this.state.blockFields}
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return "";
                }}
                styles={
                  !_.isEmpty(this.state.profissionalSelecionado) ||
                  !this.state.hasSubmitted
                    ? selectFieldWithNoIndicator
                    : selectFieldWithNoIndicatorError
                }
                onInputChange={this.onProfissionalInputChange}
                options={this.state.profissionaisSolicitantesToRender}
                ref={(input) => (this.textInput = input)}
                filterOption={this.mapFilterArrayToRenderArray}
              />
              <ErrorMsgLabel
                boolean={
                  _.isEmpty(this.state.profissionalSelecionado) &&
                  this.state.hasSubmitted
                }
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={1}
              style={{ marginTop: "30px", marginLeft: "-45px" }}
            >
              <Icon
                loading={this.state.loadingProfissional}
                name="spinner"
                size="large"
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={1}
              style={{ marginTop: "20px", marginRight: "10px" }}
            >
              <InclusaoProfissional
                callSnackbar={(msg, type) => {
                  this.setState(
                    {
                      snackbarMsg: msg,
                      snackType: type,
                    },
                    this.clickChild
                  );
                }}
                retornoListagem={(listagem, nomeNovoProfissional) => {
                  if ((nomeNovoProfissional ?? "").length > 0) {
                    this.prencherListagem(listagem);
                    this.setState({ loadingProfissional: true });

                    var find =
                      this.state.profissionaisSolicitantesToRender.filter(
                        (f) => f.profissional.Nome === nomeNovoProfissional
                      )[0];

                    if (null != find) {
                      this.profissionalSolicitanteSelect(find);
                    }
                    this.setState({ loadingProfissional: false });
                  }
                }}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={6}
              disabled={this.state.blockFields}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_OCUPACAO}
                </label>
              </div>
              <Select
                value={this.state.ocupacaoSelecionada}
                onChange={this.ocupacaoSelect}
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_EXAMES_PROCEDIMENTOS
                    .MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA;
                }}
                placeholder=""
                isDisabled={this.state.blockFields}
                styles={
                  this.state.ocupacaoSelecionada || !this.state.hasSubmitted
                    ? selectFieldStyle
                    : selectFieldStyleError
                }
                options={this.state.ocupacoes.map((ocupacao) => {
                  return {
                    value: ocupacao.Descricao,
                    label: `${ocupacao.Id} - ${ocupacao.Descricao}`,
                  };
                })}
              />
              <ErrorMsgLabel
                boolean={
                  _.isEmpty(this.state.ocupacaoSelecionada) &&
                  this.state.hasSubmitted
                }
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.clickChild = click)}
          variant={this.state.snackType}
          duration={6000}
          content={this.state.snackbarMsg}
        />
      </div>
    );
  }
}

export default connect(null, {
  getProfissionaisSolicitantesFiltro,
  getOcupacoes,
  getEstados,
  getConselhos,
})(FormSolicitacao);
